<template>
  <div class="col-auto">
    <model-table
      ref="modelTable"
      title="Modifiers"
      edit-label="Customize"
      :collection="item.itemModifierSets"
      :submodel="true"
      :columns="[
        { name: 'name', field: row => row.modifierSet.name },
        { name: 'modifiers', field: row => row.modifierSet.modifiers, component: ModifiersCell },
        { field: 'minSelectionCount', label: 'Minimum Count' },
        { field: 'maxSelectionCount', label: 'Maximum Count' },
        { name: 'actions', align: 'right' }
      ]"
      @add="$refs.dialog.show()"
    >
      <item-modifier-set-form
        :item="item"
        :submodel="true"
      />
    </model-table>
    <select-modifier-sets-dialog
      ref="dialog"
      :item="item"
      @change="forceModelTableRerender"
    />
  </div>
</template>

<script>

import Item from 'src/models/item/Item'
import ModifiersCell from 'src/modules/admin/components/model-table/components/ModifiersCell'
import ModelTable from 'src/modules/admin/components/ModelTable'
import ItemModifierSetForm from 'src/modules/admin/item/components/ItemModifierSetForm'
import SelectModifierSetsDialog from 'src/modules/admin/item/components/SelectModifierSetsDialog'

export default {
  name: 'ItemModifierSetTable',
  components: {
    ModelTable,
    SelectModifierSetsDialog,
    ItemModifierSetForm
  },
  props: {
    item: {
      type: Item,
      required: true
    }
  },
  data () {
    return {
      ModifiersCell
    }
  },
  methods: {
    forceModelTableRerender () {
      this.$refs.modelTable.reactiveTriggerKey++
    }
  }
}
</script>
